export const CustomsDeclarationInfoTooltip =
  'Митниця об`єднала ваші посилки в одну декларацію. ' +
  'На митницю одночасно прибуло декілька посилок на ваше ім`я від одного відправника. ' +
  'Такі посилки митниця об`єднує в одну партію та сумує їх вартість. ' +
  'Якщо загальна вартість понад €150, нараховуються митні платежі.';
